<template>
  <router-view/>
</template>
<style>
div{
 font-family:"Microsoft YaHei",微软雅黑;
}

</style>
